import { create } from 'zustand';
interface GTMState {
	websiteFacilityId: string;
	websiteFacilityName: string;
	appointmentFacilityId: string;
	appointmentFacilityName: string;
	reasonForVisitId: string;
	brand: string;
	platform: string;

	setWebsiteFacility: (id: string, name: string) => void;
	setAppointmentFacility: (id: string, name: string) => void;
	setReasonForVisit: (id: string) => void;
	setBrand: (brand: string) => void;
	setPlatform: (platform: string) => void;
}

export const useGTMStore = create<GTMState>((set) => ({
	websiteFacilityId: '',
	websiteFacilityName: '',
	appointmentFacilityId: '',
	appointmentFacilityName: '',
	reasonForVisitId: '',
	brand: 'WellNow',
	platform: 'nextjs',

	setWebsiteFacility: (id, name) => set(() => ({ websiteFacilityId: id, websiteFacilityName: name })),
	setAppointmentFacility: (id, name) => set(() => ({ appointmentFacilityId: id, appointmentFacilityName: name })),
	setReasonForVisit: (id) => set(() => ({ reasonForVisitId: id })),
	setBrand: (brand) => set(() => ({ brand })),
	setPlatform: (platform) => set(() => ({ platform })),
}));
